/* eslint-disable prettier/prettier */
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory, createMemoryHistory } from 'history';
import { createBlacklistFilter } from 'redux-persist-transform-filter';

import { encryptTransform } from 'redux-persist-transform-encrypt';
import rootReducers from './combineReducer';
import { actionMidlewares } from './middleware';
import gtmMiddleware from './gtmMiddleware';
import { getEnv } from '../config';

const { publicPath, enviroment, secretKeyRedux } = getEnv();

export const isServer = !(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

export const history = isServer
  ? createMemoryHistory({
      initialEntries: ['/'],
    })
  : createBrowserHistory({
      basename: publicPath,
    });

const saveSubsetBlacklistFilter = createBlacklistFilter('login', ['recover_user']);
const saveSubsetBlacklistEcommerce = createBlacklistFilter('ecommerce', ['applicationInfo']);
const saveCommonBlacklistFilter = createBlacklistFilter('common', [
  'formValidationErrors',
  'modal.open',
]);

const composeEnhancers =
  (enviroment !== 'prod' && !isServer ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : false) ||
  compose;

const keyStorage = 'falabella_persist';

const transforms = [
  saveSubsetBlacklistFilter,
  saveSubsetBlacklistEcommerce,
  saveCommonBlacklistFilter,
];

if (secretKeyRedux) {
  const encryptor = encryptTransform({
    secretKey: secretKeyRedux,
    onError(error) {
      localStorage.removeItem(keyStorage);
    },
  });
  transforms.push(encryptor);
}

const persistConfig = {
  key: keyStorage,
  storage,
  stateReconciler: hardSet,
  whitelist: ['onboarding', 'login', 'users', 'common', 'ecommerce'],
  transforms,
};

const persistedReducer = persistReducer(persistConfig, rootReducers(history));

export const store = createStore(
  persistedReducer,
  composeEnhancers(
    applyMiddleware(thunk, routerMiddleware(history), actionMidlewares, gtmMiddleware)
  )
);

export default () => {
  const persistor = persistStore(store);
  return { store, persistor };
};
